@if (!showSpinner$$() || _hasRows$$()) {
    @if (!deletedListShow$$()) {
        <cdk-virtual-scroll-viewport class="viewport" [itemSize]="itemSize$$()" [style.--shape-list-item-size.px]="itemSize$$()" @show>
            <div class="viewport-padding">
                <mat-nav-list>
                    <div *cdkVirtualFor="let listItem of listFiltered$$(); let i = index; trackBy: trackById" class="list-item-wrapper">
                        <a mat-list-item
                            (click)="emit_item_click($event, listItem)"
                            [activated]="isActivated(listItem)"
                            [class.no-click-through]="!canClickThrough$$()"
                            [class.list-item--inactive]="_rowInactive(listItem)"
                            [lines]="1"
                        >
                            @if (i >= 1) {
                                <mat-divider />
                            }
                            <ng-container *ngTemplateOutlet="template$$(); context: {$implicit: listItem}"></ng-container>
                        </a>
                    </div>
                </mat-nav-list>
            </div>
        </cdk-virtual-scroll-viewport>
    }
    @else {
        <cdk-virtual-scroll-viewport class="viewport" [itemSize]="itemSize$$()" [style.--shape-list-item-size.px]="itemSize$$()" @show>
                <div class="viewport-padding">
                    <mat-selection-list #matList
                        (selectionChange)="emit_change($event)"
                    >
                        <mat-list-option *cdkVirtualFor="let listItem of listFiltered$$(); let i = index; trackBy: trackById"
                            [value]="listItem"
                            [selected]="!listItem?.deleted"    
                        >
                            @if (i >= 1) {
                                <mat-divider />
                            }
                            <ng-container *ngTemplateOutlet="template$$(); context: {$implicit: listItem}"></ng-container>
                        </mat-list-option>
                    </mat-selection-list>
                </div>
        </cdk-virtual-scroll-viewport>
    }
    <app-list-position virtual [scrollElement]="scrollElement$$()" [list]="listFiltered$$()" [itemSize]="itemSize$$()" />
}
@if (showSpinner$$()) {
    <div class="loading-overlay" [class.loading-overlay--over]="_hasRows$$()"><div class="spinner"></div></div>
}

<ng-template #template_footer>
    <app-tablist-footer
        (onFilterChange)="emit_onFilterChange()"
    ></app-tablist-footer>
</ng-template>

<ng-template #template_buttons>
    @if (!loadingPage$$() && !buttonsHide$$()) {
        @if (mainListShow$$()) {
            <div class="button-row" [@showHide]>
                @if (btnAddShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnAdd_click()"
                        [disabled]="btnAddDisabled$$()"
                        [tooltip]="btnAddTooltip$$()"
                    >
                        <app-icon name="plus" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasDeletedList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted()"
                        [tooltip]="'deleted from list'"
                    >
                        <app-icon name="deleted-list" />
                    </app-button-action>
                }
                @if (btnDeletedListShow$$() && hasInactiveList$$()) {
                    <app-button-action
                        (btnClick)="emit_toggleDeleted(_tabModeInactive)"
                        [tooltip]="'inactive list'"
                    >
                        inactive
                    </app-button-action>
                }
            </div>
        } @else {
            <div class="button-row" [@showHide]>
                <app-button-action
                    (btnClick)="emit_toggleDeleted()"
                    [tooltip]="'cancel'"
                >
                    <app-icon name="xmark" />
                </app-button-action>
                @if (deletedListShow$$() && btnRestoreListShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
                @if (deletedListShow$$() && btnDeleteDeepShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnDeleteDeep_click()"
                        [tooltip]="'delete selection permanently'"
                        [disabled]="btnDeleteDeepDisabled$$()"
                    >
                        delete
                    </app-button-action>
                }
                @if (inactiveListShow$$()) {
                    <app-button-action
                        (btnClick)="emit_btnRestore_click()"
                        [tooltip]="'restore selection'"
                        [disabled]="btnRestoreDisabled$$()"
                    >
                        restore
                    </app-button-action>
                }
            </div>
        }
    }
</ng-template>
